import {ApiSlice} from "@/store/ApiSlice";
import RESTAPIConfig from "@/config/RESTAPIConfig";
import {FileMeaningsListInterface} from "./Interfaces/FileMeaningsListInterface";

const restApiConfig = new RESTAPIConfig();

export const FileMeaningsListApiSlice = ApiSlice.injectEndpoints({
    endpoints: builder => ({
        getFileMeanings: builder.query<FileMeaningsListInterface, void>({
            query: () => ({
                url: restApiConfig.baseUrl + restApiConfig.apiPrefixV2 + restApiConfig.fileMeaningList(),
            }),
            providesTags: ["FetchedData", "FileMeanings"]
        })
    })
});

export const {useGetFileMeaningsQuery} = FileMeaningsListApiSlice;
